/** Gate that waits for profile load then redirects new users to welcome. */
import { Navigate, useLocation } from 'react-router-dom';
import { useT } from '@/i18n/useT';
import { useOnboardingWelcomeRedirect } from '@/features/onboarding/hooks/useOnboardingWelcomeRedirect';
import { getOnboardingWelcomePath } from '@/constants/onboardingRoutes';

const OnboardingProfileGate = ({ children }) => {
  const t = useT();
  const { pathname } = useLocation();
  const { profileGateActive, shouldRedirectToWelcome } =
    useOnboardingWelcomeRedirect();

  if (profileGateActive) {
    return <div>{t('common.loading', 'Loading...')}</div>;
  }

  if (shouldRedirectToWelcome) {
    return (
      <Navigate
        to={getOnboardingWelcomePath()}
        replace
        state={{ from: pathname }}
      />
    );
  }

  return children;
};

export default OnboardingProfileGate;
